import {StatusInfoAll} from "./StatusInfoAll";
import React, {ReactElement} from "react";
import {DateTime} from "../../components/ListComponent/DateTime";

export class StatusInfoSession extends StatusInfoAll {

    componentDidMount() {

        this.request.fetch('/order/info/session', null, {method: 'GET'})
            .then((state: { item: { [key: string]: string } } | any) => {
                this.setState(state);
            }).catch(error => {
            this.onError(error);
        });
    }


    protected getInfoPanel(): ReactElement {
        const end = this.state?.end || (new Date()).toLocaleString();
        return (
            <div className="col-xl-12">
                <div className="alert alert-primary" role="alert">
                    {this.dictionary.get['session-info']}:
                    &nbsp; <DateTime value={this.state?.start} inline={true}/>&nbsp;-&nbsp;<DateTime value={end}
                                                                                                     inline={true}/>
                </div>
            </div>
        );
    }
}